import type { ProfileT } from "@patient-watch/types/database";

/** True when the user has not yet chosen a password via the app (see mark_user_password_set). */
export function needsPasswordSetup(profile: Pick<ProfileT, "has_password">): boolean {
    return !profile.has_password;
}
